import { LoadingStatus } from '.../../__legacy__/components/studio/activitybar/sample-packs/SamplePackDropdown'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import axios from '../../../__legacy__/lib/axios'

export const useFilesZipDownload = () => {
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.IDLE)
  const { enqueueSnackbar } = useSnackbar()

  const zipAndDownloadFilesFromUrls = async ({
    urls,
    zipFileName
  }: {
    urls: { fileName: string; url: string }[]
    zipFileName: string
  }) => {
    setLoadingStatus(LoadingStatus.LOADING)
    const jsZip = new JSZip()

    await Promise.all(
      urls.map(async ({ fileName, url }) => {
        const response = await axios.get<string>(url, { responseType: 'arraybuffer' })
        const { data, headers } = response

        jsZip.file(`${fileName}.${headers['content-type'].split('/').pop()}`, data)
      })
    )

    const zipFile = await jsZip.generateAsync({ type: 'blob' })
    saveAs(zipFile, zipFileName)

    setLoadingStatus(LoadingStatus.SUCCESS)
    enqueueSnackbar('Sound files downloaded!', {
      variant: 'modalSuccess'
    })
  }

  return { loadingStatus, zipAndDownloadFilesFromUrls }
}
